import qs from 'qs';
import moment from 'moment';
import api from './api';
import generateSearchRequest from '../utils/sequelize-search-builder-client';

const formatFilterValuesForILikeFilter = (filters, fields) => {
	fields.forEach((field) => {
		if (filters[field]?.iLike) {
			filters[field].iLike = `%${filters[field].iLike}%`;
		}
	});
};

const selectClient = (client) => {
	return {
		...client,
		birthdate: client.birthdate ? moment(client.birthdate).toDate() : null,
		contractedPlanDate: client.contractedPlanDate ? moment(client.contractedPlanDate) : null,
		createdAt: client.createdAt ? moment(client.createdAt).toDate() : null,
		updatedAt: client.updatedAt ? moment(client.updatedAt).toDate() : null,
	};
};

const selectClients = (clients) => clients.map(selectClient);

class ClientService {
	async getById(id) {
		return api
			.get(`/clients/${id}`)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectClient)
			.catch((error) => {
				console.log(
					`fail when trying to get client with id ${id} in ClientService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async syncronizeStatusClientWithIUGU(client) {
		return api
			.post('/clients/syncronize/status/with/iugu', client)
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					`fail when trying to syncronize client with id ${client.id} in ClientService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getAllDependets({ page = 0, size = 10, order, filters }) {
		const settings = {
			where: {
				id: {
					as: 'id',
					type: 'like',
				},
				name: {
					as: `name`,
					//type: 'iLike',
					type: 'like',
				},
				email: {
					as: 'email',
					type: 'like',
				},
				cpf: {
					as: 'cpf',
					type: 'like',
				},
				depedent: {
					as: 'depedent',
					type: 'like',
				},
				zone: {
					as: 'zone',
					type: 'like',
				},
				status: {
					as: 'status',
					type: 'like',
				},
				'status:notLike': {
					as: 'status',
					type: 'notLike',
				},
				baseName: {
					as: 'base.name',
					//type: 'iLike',
					type: 'like',
				},
				baseId: {
					as: 'baseId',
					type: 'equal',
				},
				'createdAt:between': {
					as: 'createdAt',
					type: 'between',
				},
				'createdAt:lte': {
					as: 'createdAt',
					type: 'lte',
				},
				_all: {
					as: '_all',
					type: 'like',
				},
			},
			order,
		};
		const request = generateSearchRequest(filters, settings);
		formatFilterValuesForILikeFilter(request.filter, ['name', 'base.name']);
		return api
			.get('/clients/dependents', {
				paramsSerializer: {
					serialize: function (params) {
						//console.log('paramsSerializer', params);
						return qs.stringify(params, { arrayFormat: 'brackets' });
					},
				},
				params: {
					page,
					size,
					...request,
				},
			})
			.then((response) => response.data)
			.then((data) => ({ ...data, body: selectClients(data.body) }))
			.catch((error) => {
				console.log(
					'fail when trying to get clients in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getAll({ page = 0, size = 10, order, filters }) {
		const settings = {
			where: {
				id: {
					as: 'id',
					type: 'like',
				},
				name: {
					as: `name`,
					//type: 'iLike',
					type: 'like',
				},
				email: {
					as: 'email',
					type: 'like',
				},
				cpf: {
					as: 'cpf',
					type: 'like',
				},
				depedent: {
					as: 'depedent',
					type: 'like',
				},
				zone: {
					as: 'zone',
					type: 'like',
				},
				status: {
					as: 'status',
					type: 'like',
				},
				'status:notLike': {
					as: 'status',
					type: 'notLike',
				},
				baseName: {
					as: 'base.name',
					//type: 'iLike',
					type: 'like',
				},
				baseId: {
					as: 'baseId',
					type: 'equal',
				},
				'createdAt:between': {
					as: 'createdAt',
					type: 'between',
				},
				'createdAt:lte': {
					as: 'createdAt',
					type: 'lte',
				},
				_all: {
					as: '_all',
					type: 'like',
				},
			},
			order,
		};
		const request = generateSearchRequest(filters, settings);
		formatFilterValuesForILikeFilter(request.filter, ['name', 'base.name']);
		return api
			.get('/clients', {
				paramsSerializer: {
					serialize: function (params) {
						//console.log('paramsSerializer', params);
						return qs.stringify(params, { arrayFormat: 'brackets' });
					},
				},
				params: {
					page,
					size,
					...request,
				},
			})
			.then((response) => response.data)
			.then((data) => ({ ...data, body: selectClients(data.body) }))
			.catch((error) => {
				console.log(
					'fail when trying to get clients in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async remove(id) {
		return api
			.delete(`/clients/${id}`)
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					'fail when trying to remove client in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async create(clientForm) {
		console.log('createClient', clientForm);
		return api
			.post('/clients', clientForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectClient)
			.catch((error) => {
				console.log(
					'fail when trying to create client in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async update(id, clientForm) {
		console.log('updateClient', id, clientForm);
		return api
			.patch(`/clients/${id}`, clientForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectClient)
			.catch((error) => {
				console.log(
					'fail when trying to update client in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getGenders() {
		return api
			.get('/clients/genders')
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					'fail when trying to get client genders in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getClientStatuses() {
		return api
			.get('/clients/client-statuses')
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					'fail when trying to get client statuses in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getMaritalStatuses() {
		return api
			.get('/clients/marital-statuses')
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					'fail when trying to get client marital statuses in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getPlans() {
		return api
			.get('/clients/plans')
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					'fail when trying to get client plans in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getDeliveryPreferences() {
		return api
			.get('/clients/delivery-preferences')
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					'fail when trying to get client delivery preferences in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async downloadCsv() {
		return api
			.get('/clients/download')
			.then((response) => response.data)
			.then((data) => new Blob([data], { type: 'application/csv' }))
			.then((blob) => URL.createObjectURL(blob))
			.then((uril) => {
				let link = document.createElement('a');
				link.setAttribute('href', uril);
				link.setAttribute('download', 'clientes.csv');
				let clickEvent = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: false,
				});
				link.dispatchEvent(clickEvent);
			})
			.catch((error) => {
				console.log(
					'fail when trying to download csv in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}
	async hasClientWithCpf(cpf, clientId) {
		return api
			.head(`/clients/cpf/${cpf}/${clientId}`)
			.then((response) => true)
			.catch((error) => {
				if (error.response?.status === 404) {
					return false;
				}
				console.log(
					`fail when trying to check if client with cpf ${cpf} exists in ClientService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async hasClientWithEmail(email, clientId) {
		return api
			.head(`/clients/email/${email}/${clientId}`)
			.then((response) => true)
			.catch((error) => {
				if (error.response?.status === 404) {
					return false;
				}
				console.log(
					`fail when trying to check if client with email ${email} exists in ClientService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}
}

const clientService = new ClientService();
export default clientService;
